import { put, takeLatest } from "redux-saga/effects";
import { GetDataDashboardSuccess2Action, GetDataDashboardSuccess3Action, GetDataDashboardSuccess4Action, GetDataDashboardSuccess5Action, GetDataDashboardSuccess6Action, GetDataDashboardSuccessAction, GetDataPlanDashboarSuccessAction, GetDataPlanNextWeekDashboarSuccessAction, GetDataPlanTimeExtendtionDashboarSuccessAction, RequertDataDashboardFailedAction } from "../actions";
import { GET_DATA_DASHBOARD, GET_DATA_DASHBOARD2, GET_DATA_DASHBOARD3, GET_DATA_DASHBOARD4, GET_DATA_DASHBOARD5, GET_DATA_DASHBOARD6, GET_DATA_PLAN_DASHBOARD, GET_DATA_PLAN_NEXTWEEK_DASHBOARD, GET_DATA_PLAN_TIMEEXTENTION_DASHBOARD } from "../actions/actionTypes";
import { Api } from "./api";

function* GetDataDashboard(action) {
    try {
        const DataDashboard = yield Api.GetDataDashboardFromApi(action.DataDashboard);
        yield put(GetDataDashboardSuccessAction(DataDashboard));
    }
    catch (error) {
        yield put(RequertDataDashboardFailedAction(error));
    }
}

export function* watchGetDataDashboard() {
    yield takeLatest(GET_DATA_DASHBOARD, GetDataDashboard)
}
function* GetDataDashboard2(action) {
    try {
        const DataDashboard = yield Api.GetDataDashboardFromApi(action.DataDashboard2);
        yield put(GetDataDashboardSuccess2Action(DataDashboard));
    }
    catch (error) {
        yield put(RequertDataDashboardFailedAction(error));
    }
}

export function* watchGetDataDashboard2() {
    yield takeLatest(GET_DATA_DASHBOARD2, GetDataDashboard2)
}
function* GetDataDashboard3(action) {
    try {
        const DataDashboard = yield Api.GetDataDashboard3FromApi(action.DataDashboard3);
        yield put(GetDataDashboardSuccess3Action(DataDashboard));
    }
    catch (error) {
        yield put(RequertDataDashboardFailedAction(error));
    }
}

export function* watchGetDataDashboard3() {
    yield takeLatest(GET_DATA_DASHBOARD3, GetDataDashboard3)
}
function* GetDataDashboard4(action) {
    try {
        const DataDashboard = yield Api.GetDataDashboard4FromApi(action.DataDashboard4);
        yield put(GetDataDashboardSuccess4Action(DataDashboard));
    }
    catch (error) {
        yield put(RequertDataDashboardFailedAction(error));
    }
}

export function* watchGetDataDashboard4() {
    yield takeLatest(GET_DATA_DASHBOARD4, GetDataDashboard4)
}
function* GetDataDashboard5(action) {
    try {
        const DataDashboard = yield Api.GetDataDashboard5FromApi(action.DataDashboard5);
        yield put(GetDataDashboardSuccess5Action(DataDashboard));
    }
    catch (error) {
        yield put(RequertDataDashboardFailedAction(error));
    }
}

export function* watchGetDataDashboard5() {
    yield takeLatest(GET_DATA_DASHBOARD5, GetDataDashboard5)
}
function* GetDataDashboard6(action) {
    try {
        const DataDashboard = yield Api.GetDataDashboard6FromApi(action.DataDashboard6);
        yield put(GetDataDashboardSuccess6Action(DataDashboard));
    }
    catch (error) {
        yield put(RequertDataDashboardFailedAction(error));
    }
}

export function* watchGetDataDashboard6() {
    yield takeLatest(GET_DATA_DASHBOARD6, GetDataDashboard6)
}
function* GetDataPlanDashboard() {
    try {
        const DataDashboard = yield Api.GetDataPlanDashboard2FromApi();
        yield put(GetDataPlanDashboarSuccessAction(DataDashboard));
    }
    catch (error) {
        yield put(RequertDataDashboardFailedAction(error));
    }
}

export function* watchGetDataPlanDashboard() {
    yield takeLatest(GET_DATA_PLAN_DASHBOARD, GetDataPlanDashboard)
}
function* GetDataPlanNextWeekDashboard(action) {
    try {
        const DataDashboard = yield Api.GetDataPlanDashboardFromApi(action.DataNextWeek);
        yield put(GetDataPlanNextWeekDashboarSuccessAction(DataDashboard));
    }
    catch (error) {
        yield put(RequertDataDashboardFailedAction(error));
    }
}

export function* watchGetDataPlanNextWeekDashboard() {
    yield takeLatest(GET_DATA_PLAN_NEXTWEEK_DASHBOARD, GetDataPlanNextWeekDashboard)
}
function* GetDataPlanTimeExtendtionDashboard(action) {
    try {
        const DataDashboard = yield Api.GetDataPlanDashboard3FromApi(action.DataTimeExtend);
        yield put(GetDataPlanTimeExtendtionDashboarSuccessAction(DataDashboard));
    }
    catch (error) {
        yield put(RequertDataDashboardFailedAction(error));
    }
}

export function* watchGetDataPlanTimeExtendtionDashboard() {
    yield takeLatest(GET_DATA_PLAN_TIMEEXTENTION_DASHBOARD, GetDataPlanTimeExtendtionDashboard)
}